import { useLocation } from 'react-router-dom';

export const useVisibility = () => {
  const location = useLocation();
  return { columnStateSaveId: `${location.pathname}-table-columns` };
};
